<template>
  <cube-drawer
    title="自定义布局紧凑"
    :visible="visible"
    :size="'20%'"
    :modal="true"
    custom-class="drawerEditor"
    @close="closeDrawer"
  >
    <div class="drawerEditor-body">
      <el-row v-for="(item, index) in spaceConfig" :key="index">
        <el-col class="editor-tit">{{ item.groupName }}</el-col>
        <el-form>
          <el-form-item
            v-for="(groupItem, groupIndex) in item.group"
            :key="groupIndex"
            :label="groupItem.name"
          >
            <el-slider
              v-model="groupItem.curKey"
              :min="groupItem.key[0]"
              :max="groupItem.key[1]"
              @change="changeCurKey"
            ></el-slider>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
    <div slot="footer" class="drawerEditor-foot">
      <el-button
        :disabled="componentStyle ==''"
        type="info"
        @click="downloadCss"
        >下载css文件</el-button
      >
      <div>
        <el-button
          :disabled="componentStyle == ''"
          type="primary"
          icon="el-icon-refresh-left"
          @click="resetCss"
          >复原</el-button
        >
        <el-button type="primary" @click="saveCSS">保存</el-button>
      </div>
    </div>
  </cube-drawer>
</template>
<script>
import componentConfig from './componentSpace.json'
export default {
  props: {
    showEditor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.showEditor,
      spaceConfig: '',
      componentStyle: ''
    }
  },
  computed: {},
  watch: {
    showEditor(newVal, oldVal) {
      this.visible = newVal
      var localStorageConfig = JSON.parse(localStorage.getItem('spaceStyle'))
      if (localStorageConfig !== null) {
        this.spaceConfig = localStorageConfig.saveConfig
        this.componentStyle = {
          root: localStorageConfig.saveStyles
        }
        this.$emit('getComponentStyle', {
          type: 'space',
          saveStyles: this.componentStyle.root
        })
      } else {
        this.spaceConfig = this.resetConfig(componentConfig)
      }
    }
  },
  mounted() {
    var localStorageConfig = JSON.parse(localStorage.getItem('spaceStyle'))
    if (localStorageConfig !== null) {
      this.spaceConfig = localStorageConfig.saveConfig
    } else {
      this.spaceConfig = this.resetConfig(componentConfig)
    }
  },
  methods: {
    resetConfig(spaceConfig) {
      console.log(spaceConfig, '??????')
      var config = JSON.parse(JSON.stringify(spaceConfig))
      config.forEach((item) => {
        item.group.forEach((group) => {
          group.editorKey = ''
          group.oldKey = group.curKey
        })
      })
      return config
    },
    closeDrawer() {
      this.$emit('ifEditor', 'space', false)
    },
    changeCurKey() {
      this.componentStyle = this.getcss(this.spaceConfig)
      this.$emit('getComponentStyle', {
        type: 'space',
        saveStyles: this.componentStyle.root
      })
    },
    getcss(config) {
      const result = {}
      for (let i = 0; i < config.length; i++) {
        const group = config[i].group
        for (let j = 0; j < group.length; j++) {
          const curKey = group[j].curKey
          const cssVariables = group[j].cssVariable
          for (let k = 0; k < cssVariables.length; k++) {
            if (curKey !== group[j].oldKey) {
              result[cssVariables[k]] = curKey
            }
          }
        }
      }
      var root = ''
      var ag = ''
      for (const [key, value] of Object.entries(result)) {
        if (key.startsWith('--ag')) {
          ag += `${key}: ${value / 100}rem;`
        } else {
          root += `${key}: ${value / 100}rem;`
        }
      }
      // 动态ag插入style
      const el = document.getElementsByClassName('ag-theme-balham')
      const agColor =
        localStorage.getItem('agColorStyle') != null
          ? localStorage.getItem('agColorStyle')
          : ''
      const agStyle = ag + agColor
      for (let i = 0; i < el.length; i++) {
        this.$nextTick(() => {
          el[i].style = agStyle
        })
      }
      return { root, ag }
    },
    saveCSS() {
      if (this.componentStyle !== '') {
        var saveConfig = this.spaceConfig
        var saveStyles = this.componentStyle.root
        var obj = {
          saveStyles,
          saveConfig
        }
        localStorage.setItem('spaceStyle', JSON.stringify(obj))
        localStorage.setItem('agSpaceStyle', this.getcss(this.spaceConfig).ag)
        this.$emit('getComponentStyle', {
          type: 'space',
          saveStyles
        })
      }
      this.$emit('ifEditor', 'space', false)
    },
    downloadCss() {
      var css = this.getcss(this.spaceConfig)
      var cont = `
     .spacing-name,
     .ag-theme-balham.spacing-name {
      // 此处spacing-name为紧凑名称
        ${css.root}
        ${css.ag}
        &.var100,
        &.var110,
        &.var125,
        &.var137,
        &.var150 {
            ${css.ag}
          }
      }`
      var aTag = document.createElement('a')
      var blob = new Blob([cont])
      aTag.download = 'spaceStyle.scss'
      aTag.href = URL.createObjectURL(blob)
      aTag.click()
      URL.revokeObjectURL(blob)
    },
    resetCss() {
      this.componentStyle = ''
      this.$emit('getComponentStyle', {
        type: 'space',
        saveStyles: this.componentStyle.root
      })
      this.spaceConfig = this.resetConfig(componentConfig)
      window.localStorage.removeItem('spaceStyle')
    }
  }
}
</script>
